import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mapDefinedParams } from '@highlander/services/helpers';
import { AlertLogResponse, AlertLogsQueryParams } from '@models/index';
import { map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AlertLogsService {
  private readonly url = `${environment.bffUrl}/monitoring/logs`;

  constructor(private httpClient: HttpClient) {}

  prevQuery: AlertLogsQueryParams | null = null;
  private _continuationToken: string = '';

  getAll(query: AlertLogsQueryParams): Observable<AlertLogResponse[]> {
    const params = mapDefinedParams(query);

    return this.httpClient
      .get<AlertLogResponse[]>(this.url, {
        params,
        headers: {
          'x-highlander-continuation-token': this.getContinuationToken(JSON.stringify(this.prevQuery) !== JSON.stringify(query)),
        },
        observe: 'response',
      })
      .pipe(
        tap(res => {
          this.prevQuery = query;
          this._continuationToken = res.headers.get('x-highlander-continuation-token') ?? '';
        }),
        map(res => res.body!),
      );
  }

  getOne(id: string): Observable<AlertLogResponse> {
    return this.httpClient.get<AlertLogResponse>(`${this.url}/${id}`);
  }

  private getContinuationToken(didQueryParamsChange: boolean): string {
    if (didQueryParamsChange) return '';

    return this._continuationToken;
  }

  resetContinuationToken(): void {
    this._continuationToken = '';
    this.prevQuery = null;
  }
}
